(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cl-menu-intent')) {
    const OPEN_DELAY = 140;
    const CLOSE_DELAY = 250;
    const noHover = window.matchMedia('(hover: none)');

    /**
     * Hover intent for the header mega menu: a panel opens after the pointer rests on its item for
     * OPEN_DELAY ms and closes CLOSE_DELAY ms after the pointer leaves, so crossing an item or
     * briefly slipping off the panel does not flicker it. Opening/closing itself (aria-expanded,
     * inert, Escape, one panel at a time) stays in Horizon's header-menu component.
     * Keyboard: Enter/Space on the chevron toggles (Horizon); ArrowDown on a top link opens the panel
     * and moves focus into it. Touch without hover: the first tap opens the panel, the second follows the link.
     */
    class ClMenuIntent extends HTMLElement {
      /** @type {AbortController | undefined} */
      #abort;
      /** @type {number | undefined} */
      #openTimer;
      /** @type {number | undefined} */
      #closeTimer;

      connectedCallback() {
        const menu = this.closest('header-menu');
        if (!menu) return;
        this.#abort = new AbortController();
        const { signal } = this.#abort;

        for (const item of menu.querySelectorAll('.menu-list__list-item[data-cl-intent]')) {
          item.addEventListener('pointerenter', (event) => this.#enter(menu, item, event), { signal });
          item.addEventListener('pointerleave', (event) => this.#leave(menu, event), { signal });
          item.addEventListener('click', (event) => this.#tap(menu, item, event), { signal });
          item.addEventListener('keydown', (event) => this.#keydown(menu, item, event), { signal });
        }
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#clear();
      }

      #clear() {
        clearTimeout(this.#openTimer);
        clearTimeout(this.#closeTimer);
      }

      /** @param {Element} item */
      static isOpen(item) {
        return item.querySelector(':scope > .menu-list__trigger [aria-expanded="true"]') !== null;
      }

      /**
       * @param {any} menu
       * @param {HTMLElement} item
       * @param {PointerEvent} event
       */
      #enter(menu, item, event) {
        if (event.pointerType === 'touch') return;
        this.#clear();
        this.#openTimer = setTimeout(() => menu.activate({ target: item }), OPEN_DELAY);
      }

      /**
       * @param {any} menu
       * @param {PointerEvent} event
       */
      #leave(menu, event) {
        if (event.pointerType === 'touch') return;
        clearTimeout(this.#openTimer);
        this.#closeTimer = setTimeout(() => menu.deactivate(event), CLOSE_DELAY);
      }

      /**
       * @param {any} menu
       * @param {HTMLElement} item
       * @param {MouseEvent} event
       */
      #tap(menu, item, event) {
        if (!noHover.matches) return;
        const target = event.target instanceof Element ? event.target : null;
        if (!target?.closest('.menu-list__trigger > .menu-list__link')) return;
        if (ClMenuIntent.isOpen(item)) return;
        event.preventDefault();
        this.#clear();
        menu.activate({ target: item });
      }

      /**
       * @param {any} menu
       * @param {HTMLElement} item
       * @param {KeyboardEvent} event
       */
      #keydown(menu, item, event) {
        if (event.key !== 'ArrowDown') return;
        const target = event.target instanceof Element ? event.target : null;
        const panel = item.querySelector(':scope > .menu-list__submenu');
        if (!panel || !target?.closest('.menu-list__trigger')) return;
        event.preventDefault();
        this.#clear();
        if (!ClMenuIntent.isOpen(item)) menu.activate({ target: item });
        requestAnimationFrame(() => {
          const first = panel.querySelector('a[href], button:not([disabled]), input');
          if (first instanceof HTMLElement) first.focus();
        });
      }
    }

    customElements.define('cl-menu-intent', ClMenuIntent);
  }
  } catch(e) { console.error(e); }
})();

})();
